import { useState, useEffect } from 'react';

const userTypes = [
  { text: 'Content Creators', description: 'Generate accessible alt text for your images' },
  { text: 'Developers', description: 'Integrate AI-powered tools into your applications' },
  { text: 'Bloggers', description: 'Create engaging blog content with AI assistance' },
  { text: 'E-commerce Owners', description: 'Optimize product images for SEO and accessibility' },
  { text: 'Accessibility Advocates', description: 'Make the web more accessible for everyone' },
];

export default function RotatingUserText() {
  const [currentUser, setCurrentUser] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentUser((prev) => (prev + 1) % userTypes.length);
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="text-center">
      <p className="text-xl text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
        Perfect for <span className="font-semibold text-primary-600 dark:text-primary-400">{userTypes[currentUser].text}</span> - {userTypes[currentUser].description}
      </p>
    </div>
  );
}

